import ProjectPlanTemplatesPage from "@Quest/ProjectPlanTemplates/Pages/ProjectPlanTemplatesPage.vue";

export const routes = [
    {
        path: "/enterprise/business-case-templates/:workspaceId/:strategyId",
        component: ProjectPlanTemplatesPage
    },
]
